import { render, staticRenderFns } from "./PlugimmoAddress.vue?vue&type=template&id=31bd89a2&"
import script from "./PlugimmoAddress.vue?vue&type=script&lang=ts&"
export * from "./PlugimmoAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports